(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["V3-steering-wheel-installation-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const namespace = 'CSWWInstallationGuide';

    const initializeGuide = (root) => {
      if (!root || root.dataset.cswwInitialized === 'true') return;
      root.dataset.cswwInitialized = 'true';

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const steps = Array.from(root.querySelectorAll('[data-csww-step]'));
      const nav = root.querySelector('[data-csww-step-nav]');
      const navLinks = Array.from(root.querySelectorAll('[data-csww-nav-link]'));
      const progressBar = root.querySelector('[data-csww-progress-bar]');
      const progressText = root.querySelector('[data-csww-progress-text]');
      const progressPrefix = root.dataset.progressPrefix || 'Step';
      const progressSeparator = root.dataset.progressSeparator || 'of';
      let activeIndex = -1;
      let ticking = false;

      const setActiveStep = (index, shouldCenterNav = false) => {
        if (!steps.length) return;
        const safeIndex = Math.max(0, Math.min(index, steps.length - 1));
        if (safeIndex === activeIndex && !shouldCenterNav) return;
        activeIndex = safeIndex;
        const activeId = steps[safeIndex].id;

        navLinks.forEach((link) => {
          const isActive = link.getAttribute('href') === `#${activeId}`;
          if (isActive) {
            link.setAttribute('aria-current', 'step');
            if (shouldCenterNav || window.innerWidth < 750) {
              link.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
            }
          } else {
            link.removeAttribute('aria-current');
          }
        });

        if (progressBar) {
          progressBar.style.width = `${((safeIndex + 1) / steps.length) * 100}%`;
        }
        if (progressText) {
          progressText.textContent = `${progressPrefix} ${safeIndex + 1} ${progressSeparator} ${steps.length}`;
        }
      };

      const updateFromScroll = () => {
        ticking = false;
        if (!steps.length) return;
        const mobile = window.innerWidth < 750;
        const offset = mobile
          ? parseFloat(getComputedStyle(root).getPropertyValue('--csww-mobile-sticky-offset')) + 84
          : parseFloat(getComputedStyle(root).getPropertyValue('--csww-sticky-offset')) + 28;
        let candidate = 0;
        steps.forEach((step, index) => {
          if (step.getBoundingClientRect().top <= offset) candidate = index;
        });
        setActiveStep(candidate);
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateFromScroll);
      };

      navLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const selector = link.getAttribute('href');
          const target = selector ? root.querySelector(selector) : null;
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          const index = Number(link.dataset.stepIndex || 0);
          setActiveStep(index, true);
          if (history.replaceState) history.replaceState(null, '', selector);
        });
      });

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate, { passive: true });
      setActiveStep(0);
      requestUpdate();

      const lightbox = root.querySelector('[data-csww-lightbox]');
      const lightboxImage = root.querySelector('[data-csww-lightbox-image]');
      const lightboxClose = root.querySelector('[data-csww-lightbox-close]');

      root.addEventListener('click', (event) => {
        const zoomTrigger = event.target.closest('[data-csww-zoom]');
        if (!zoomTrigger || !lightbox || !lightboxImage) return;
        lightboxImage.src = zoomTrigger.dataset.zoomSrc || '';
        lightboxImage.alt = zoomTrigger.dataset.zoomAlt || '';
        if (typeof lightbox.showModal === 'function') lightbox.showModal();
        else lightbox.setAttribute('open', '');
      });

      const closeLightbox = () => {
        if (!lightbox) return;
        if (typeof lightbox.close === 'function' && lightbox.open) lightbox.close();
        else lightbox.removeAttribute('open');
      };

      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      if (lightbox) {
        lightbox.addEventListener('click', (event) => {
          if (event.target === lightbox) closeLightbox();
        });
        lightbox.addEventListener('close', () => {
          if (lightboxImage) {
            lightboxImage.removeAttribute('src');
            lightboxImage.alt = '';
          }
        });
      }

      const backToTop = root.querySelector('[data-csww-back-to-top]');
      if (backToTop) {
        const updateBackToTop = () => {
          const rect = root.getBoundingClientRect();
          backToTop.hidden = !(rect.top < -500 && rect.bottom > 140);
        };
        window.addEventListener('scroll', updateBackToTop, { passive: true });
        updateBackToTop();
        backToTop.addEventListener('click', () => {
          root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        });
      }

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const selected = event.target && event.target.closest ? event.target.closest('[data-csww-step]') : null;
          if (!selected || !root.contains(selected)) return;
          const index = steps.indexOf(selected);
          if (index >= 0) setActiveStep(index, true);
          selected.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-csww-guide]').forEach(initializeGuide);
      if (scope.matches && scope.matches('[data-csww-guide]')) initializeGuide(scope);
    };

    if (!window[namespace]) {
      window[namespace] = { initializeAll };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initializeAll());
      } else {
        initializeAll();
      }
      document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    } else {
      window[namespace].initializeAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csw-14-in-stock-wraps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.stockInitialised === 'true') return;
      root.dataset.stockInitialised = 'true';

      const grid = root.querySelector('[data-stock-grid]');
      const search = root.querySelector('[data-stock-search]');
      const clear = root.querySelector('[data-stock-clear]');
      const sort = root.querySelector('[data-stock-sort]');
      const count = root.querySelector('[data-stock-count]');
      const empty = root.querySelector('[data-stock-empty]');
      if (!grid || !count || !empty) return;

      const cards = Array.from(grid.querySelectorAll('[data-stock-card]'));
      const normalise = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

      const render = () => {
        const query = search ? normalise(search.value) : '';
        const terms = query.split(' ').filter(Boolean);
        const mode = sort ? sort.value : 'featured';
        const ordered = cards.slice().sort((a, b) => {
          if (mode === 'title') return a.dataset.title.localeCompare(b.dataset.title);
          if (mode === 'price-low') return Number(a.dataset.price) - Number(b.dataset.price);
          if (mode === 'price-high') return Number(b.dataset.price) - Number(a.dataset.price);
          return Number(a.dataset.index) - Number(b.dataset.index);
        });

        const fragment = document.createDocumentFragment();
        let visible = 0;
        ordered.forEach((card) => {
          const haystack = normalise(card.dataset.search || '');
          const matches = terms.every((term) => haystack.includes(term));
          card.hidden = !matches;
          if (matches) visible += 1;
          fragment.appendChild(card);
        });
        grid.appendChild(fragment);

        const template = count.dataset.template || '[count]';
        count.textContent = template.replace('[count]', String(visible));
        empty.hidden = visible !== 0;
        if (clear) clear.hidden = query.length === 0;
      };

      if (search) search.addEventListener('input', render);
      if (sort) sort.addEventListener('change', render);
      if (clear && search) {
        clear.addEventListener('click', () => {
          search.value = '';
          search.focus();
          render();
        });
      }
      render();
    };

    const initialiseAll = () => {
      document.querySelectorAll('.csw-stock').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialise(event.target.querySelector('.csw-stock'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
